import React from "react";
import { StyleSheet, Text, View } from "react-native";

import OnboardingBaseScreen from "./Components/OnboardingBaseScreen";

import type { AppUserSession } from "@/schemas/auth/session";
import { Spacings } from "@/styling/spacings";
import BasicAttributes from "@/Components/PersonalAttributes/BasicAttributes";
import { AttributeCardDisplayVariantType } from "@/Components/PersonalAttributes/types";
import NoteCard from "@/Components/Cards/NoteCard";

type Props = {
  session: AppUserSession;
};

function OnboardingPersonalDetailsScreen({
  session,
}: Props): React.JSX.Element {
  const stageMainComponent: React.JSX.Element = (
    <View style={styles.sectionContainer}>
      <Text style={styles.sectionTitle}>{"Personal Details"}</Text>
      <NoteCard
        text="Filling out these details helps everyone know who you are from the
          start. It's the best way to skip the guessing games and spark
          genuine connections."
      />
      <BasicAttributes
        session={session}
        attributes={{}}
        variant={AttributeCardDisplayVariantType.ONBOARDING}
      />
    </View>
  );

  return (
    <OnboardingBaseScreen
      session={session}
      title={"Build Your Profile"}
      subtitle="Let's get your profile set up so you can start meeting amazing
          people."
      canContinue={true}
      stageMainComponent={stageMainComponent}
    />
  );
}

const styles = StyleSheet.create({
  sectionContainer: {
    flexDirection: "column",
    alignItems: "center",
    marginHorizontal: Spacings.s3,
    marginBottom: Spacings.s3,
    flex: 1,
  },
  sectionTitle: {
    fontSize: 20,
    marginBottom: Spacings.s3,
    fontWeight: "bold",
  },
});

export default OnboardingPersonalDetailsScreen;
